"use client"
import {
    ImperativeHandler,
    renderImperatively
} from "@/app/utils/render-imperatively";
import {InternalToast, ToastProps} from "@/app/_components/Toast/Toast";
import {mergeProps} from "@/app/utils/with-default-props";
import {RenderHandler, renderToast} from "@/app/_components/Toast/render";

let currentHandler: RenderHandler | null = null
let currentTimeout: number | null = null

export type ToastShowProps = Omit<ToastProps, 'visible'>

const defaultProps = {
    duration: 2000,
    position: 'center',
}

export type ToastHandler = {
    close: () => void
}

const ToastInner = (
    props: ToastShowProps & {
        onClose?: () => void
    }
) => <InternalToast {...props} />

export function show(p: ToastShowProps | string) {
    const props = mergeProps(
        defaultProps,
        typeof p === "string" ? { content: p } : p
    )

    const element = (
        <ToastInner
            {...props}
            onClose={() => {
                currentHandler = null
            }}
        />
    )

    if (currentHandler) {
        // if (currentHandler.isRendered?.()) {
        //     currentHandler.replace(element)
        // } else {
        //     currentHandler.close()
        //     currentHandler = renderToast(element)
        // }
        currentHandler.close()
        currentHandler = renderToast(element)
    } else {
        currentHandler = renderToast(element)
    }

    if (currentTimeout) {
        window.clearTimeout(currentTimeout)
    }
    if (props.duration !== 0) {
        currentTimeout = window.setTimeout(() => {
            clear()
        }, props.duration)
    }

    return currentHandler as ToastHandler
}

export function clear() {
    currentHandler?.close()
    currentHandler = null;
}

export function config(
    val: Pick<ToastProps, 'duration' | 'position'>
) {
    if (val.duration !== undefined) {
        defaultProps.duration = val.duration
    }
    if (val.position !== undefined) {
        defaultProps.position = val.position
    }
}